import { message } from "antd";
import { MessageType } from "../../../types/messageType";

export const MessageAnt = (type = MessageType.success, msg = "") => {
	if (MessageType.success === type) {
		message.success(msg);
	}

	if (MessageType.warning === type) {
		message.warning(msg);
	}

	if (MessageType.error === type) {
		message.error(msg);
	}

    if (MessageType.loading === type) {
        message.loading(msg);
    }
};
